<div id="heading">
    <h1>Financials</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Financials</li>
        </ol>
    </nav>
</div>

<div id="financials">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>Balance Sheets</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li *ngFor="let doc of documents" [class.active]="src === doc.path">
                            <a (click)="changeDoc(doc.path)">{{doc.title}}</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-md-9">
                <div class="card shadow-lg">
                    <h5 class="card-title text-center">Financials</h5>
                    <div class="card-body">
                        <div id="detail" class="text-center">
                            <pdf-viewer [src]="src" [render-text]="true" style="display: block;"
                                id="list-view"></pdf-viewer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>